/*
 * Copyright (c) 2026. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { fromGender } from "@/src/services/formServiceFunctions";

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "@/src/components/Form/Common/Style/summaryStyle";
import Typography from "@mui/material/Typography";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { Box } from "@mui/material";
import SummaryDetailsItem from "@/src/components/Form/Common/SummaryDetailsItem/SummaryDetailsItem";

type ContactDataProps = {
  formData: AbstractCase | Record<string, any>;
  product: AbstractCase;
  withInsurance?: boolean;
};

const ContactData = ({ formData, product, withInsurance = true }: ContactDataProps) => {
  const personType = "alimonyPartner";
  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h6"}>Persönliche Angaben</Typography>
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={personType + ".person.gender"} />
        Anrede
      </Grid>
      <Grid size={12}>
        {fromGender(formData.alimonyPetitioner.person.gender) || "Keine Anrede"}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={personType + ".person.givenName"} />
        Vorname
      </Grid>
      <Grid size={12}>
        {formData.alimonyPetitioner.person.givenName}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={personType + ".person.familyName"} />
        Nachname
      </Grid>
      <Grid size={12}>
        {formData.alimonyPetitioner.person.familyName}
      </Grid>
      <SummaryDetailsItem fieldPath={"customer.telephone"} caseData={product} />
      {withInsurance && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"insurancePolicyNumber"} />
            Versichertennummer
          </Grid>
          <Grid size={12}>
            {formData.caseInsurance.insurancePolicyNumber}
          </Grid>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"caseReferenceNumber"} />
            Schadennummer
          </Grid>
          <Grid size={12}>
            {formData.caseInsurance.caseReferenceNumber}
          </Grid>
        </>
      )}
    </>
  );
};

export default ContactData;
